import { useMemo as v, useState as w, useRef as O, useEffect as l } from "react";
const R = ({
  input: e,
  stopCondition: r,
  outputHandler: c,
  updateInterval: u
}) => {
  const t = v(
    () => c(e),
    [c, e]
  ), [m, f] = w(t), s = O(0);
  return l(() => {
    f(t);
  }, [t]), l(() => {
    if (e !== null && !(r && r(e)))
      return s.current = window.setInterval(() => {
        const a = c(e);
        r && r(e) && clearInterval(s.current), f(a);
      }, u), () => {
        clearInterval(s.current);
      };
  }, [e, c, r, u]), m;
};
export {
  R as useWatcher
};
